import { Currency } from '@/core/currency/interfaces';

const BRL: Currency = {
    name: 'Brazilian Real',
    demonym: 'Brazilian',
    majorSingle: 'Real',
    majorPlural: 'Reais',
    codeNumeric: '986',
    symbol: 'R$',
    symbolNative: 'R$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BRL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BRL;
